export const UPDATE_COUNTRIES = 'UPDATE_COUNTRIES';
export const UPDATE_CONDITION_OPERATOR = 'UPDATE_CONDITION_OPERATOR';
export const UPDATE_JOB_LEVELS = 'UPDATE_JOB_LEVELS';
export const UPDATE_METRIC_NAMES = 'UPDATE_METRIC_NAMES';
export const UPDATE_TENURE_OPERATORS = 'UPDATE_TENURE_OPERATORS';
